import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

export const validatCardJSX = () => {
  return (
    <div className='order-history card-validate'>
      <div className='order-processing-info-container'>
        <div className={`col-12 orderProcessingProgressBar`} data-testid='orderConfirmItems-component'>
          <div className='orderProcessingProgressBarContainer col-12'>
            <div className={`col-12 current-order-status`}>
              {translateWithI18Next(TRANSLATE_MAPPING_KEY?.VALIDATING)}
            </div>
            <div className='col-12 progress-bar-cont'>
              <div id='progressBarContainer' className={`col-sm-3 col-10 progress-bar-container`}>
                <div id='progressBar' className='progress-bar' data-testid='load-component'></div>
              </div>
            </div>
            <div className='confirm-order-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.NEW_CARD)}</div>
            <div className='confirm-order-text-cont col-12'>
              <div className='progress-bar-text col-6'>
                {translateWithI18Next(TRANSLATE_MAPPING_KEY?.CARD_VALIDATION_MESSAGE)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
